import DownloadingFiles from './DownloadingFiles'
Vue.component('DownloadingFiles', DownloadingFiles)



// WEBPACK FOOTER //
// ./src/js/components/DownloadingFiles/index.js